import axios from '../Utility/axiosconfig'

const preAuctionBid = async (body) => {
    await axios.post('/api_bidding/biddingAPI', body)
    return true
}

export default preAuctionBid
